// Reducer constants
import { INITIAL_COMPLIANCE_REPORT_TYPE_FILTER_STATE } from './compliance-report-type/compliance-report-type.reducer';
import { INITIAL_COMPLIANCE_DESIGNATION_TYPE_FILTER_STATE } from 'FoldersApp/apps/compliance-report-history-app/state/compliance-designation-type/compliance-designation-type.reducer';

import { DESC } from 'Angular/constants/core.constants';
import { ComplianceReportHistoryPageSortColumn } from 'FoldersApp/apps/compliance-report-history-app/constants';
import { ComplianceReportHistoryStore } from './interfaces/compliance-report-history-store.interface';

export const COMPLIANCE_REPORT_HISTORY_APP_STATE_SLICE_KEY: string = 'complianceReportHistory';

export const COMPLIANCE_REPORT_HISTORY_STATE_KEYS: string[] = [
    'endDate',
    'reportType',
    'designationType',
    'sortColumn',
    'sortDirection',
    'startDate',
];

export const COMPLIANCE_REPORT_HISTORY_PARAM_KEYS: string[] = [...COMPLIANCE_REPORT_HISTORY_STATE_KEYS, 'title'];

/**
 * This constant is used by the App State Service to set all the filter options on the compliance report history page
 * back to a default state. This constant has the same structure as the ComplianceReportHistoryStore interface
 * but without the page or report data.
 */
export const COMPLIANCE_REPORT_HISTORY_SYSTEM_DEFAULT_STATE: Omit<ComplianceReportHistoryStore, 'data'> = {
    endDate: null,
    title: '',
    reportType: INITIAL_COMPLIANCE_REPORT_TYPE_FILTER_STATE,
    designationType: INITIAL_COMPLIANCE_DESIGNATION_TYPE_FILTER_STATE,
    startDate: null,
    sortColumn: ComplianceReportHistoryPageSortColumn.DOWNLOAD_DATE,
    sortDirection: DESC,
    showFiltersSidebar: true,
};
